export default __webpack_public_path__ + "static/uizard_logo_yellow-b4d441d48c73735785c41e12eec6c8bd.png";